module.exports = __webpack_public_path__ + "img/monterey_auto_tilt.9c545efb.jpg";